/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProgramasControllerBorrarPrograma$Params {

/**
 * UUID del programa a borrar
 */
  uuidPrograma: string;
}

export function programasControllerBorrarPrograma(http: HttpClient, rootUrl: string, params: ProgramasControllerBorrarPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, programasControllerBorrarPrograma.PATH, 'delete');
  if (params) {
    rb.path('uuidPrograma', params.uuidPrograma, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

programasControllerBorrarPrograma.PATH = '/api/programas/borrar-programa/{uuidPrograma}';
